"use client";

import * as React from "react";

import * as SwitchPrimitive from "@radix-ui/react-switch";

import { cn } from "@perceptron/utils/cn";

interface SwitchProps extends React.ComponentProps<typeof SwitchPrimitive.Root> {
  thumbClassName?: string;
}

function Switch({ className, thumbClassName, children, ...props }: SwitchProps) {
  return (
    <SwitchPrimitive.Root
      className={cn(
        "shadow-xs focus-visible:border-ring focus-visible:ring-ring/50 data-[state=checked]:bg-switch-checked data-[state=unchecked]:bg-switch-unchecked data-[state=checked]:hover:bg-switch-checkedHover data-[state=unchecked]:hover:bg-switch-uncheckedHover dark:data-[state=unchecked]:bg-input/80 peer inline-flex h-[1.15rem] w-8 shrink-0 items-center rounded-full border border-transparent outline-none transition-all focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      data-slot="switch"
      {...props}
    >
      <SwitchPrimitive.Thumb
        className={cn(
          "dark:data-[state=checked]:bg-primary-foreground dark:data-[state=unchecked]:bg-foreground pointer-events-none flex size-4 items-center justify-center rounded-full bg-white ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0",
          thumbClassName,
        )}
        data-slot="switch-thumb"
      >
        {children}
      </SwitchPrimitive.Thumb>
    </SwitchPrimitive.Root>
  );
}

export { Switch };
